import { useSelector } from 'react-redux';

import { projectSelectors } from '../../../../store/modules/project';
import { semrushSelectors } from '../../../../store/modules/semrush';
import { userSelectors } from '../../../../store/modules/user';
import { videoFolderSelectors } from '../../../../store/modules/videoFolder';
import VideoFoldersLoader from '../components/VideoFoldersLoader';

const useVideoFoldersLoader = () => {
  const isUserPending = useSelector(userSelectors.selectUserPending);
  const isError = !!useSelector(videoFolderSelectors.selectCurrentFolderError);
  const isFolderTreePending = !!useSelector(videoFolderSelectors.selectFolderTreePending);

  const isSemrushError = useSelector(semrushSelectors.selectSemrushIsError);
  const isSemrushPending = useSelector(semrushSelectors.selectSemrushIsPending);

  const isPending =
    useSelector(videoFolderSelectors.selectCurrentFolderPendingStatus) ||
    isUserPending ||
    isFolderTreePending ||
    isSemrushError ||
    isSemrushPending;

  const isLoader = isPending && !isError;
  const isSearchPending = useSelector(projectSelectors.selectSearchProjectsPending);

  const LoaderOrNull = () => (isLoader || isSearchPending ? <VideoFoldersLoader /> : null);

  return [isLoader, LoaderOrNull] as const;
};

export default useVideoFoldersLoader;
